import type { ImportedInvoiceReviewLineValues } from '../types/importedInvoiceReviewFormSchema'

export const isImportedInvoiceReviewLineEmpty = (line: ImportedInvoiceReviewLineValues): boolean =>
  !line.description.trim() && line.amountExclVat === null && line.categoryId === null && line.vatRateId === null
